import { getFolderColor } from 'owa-folders-constants/lib/getFolderColor';
import getFolderViewStateFromId from './getFolderViewStateFromId';

export const getCustomFolderColor = (folderId: string): string | undefined => {
    const viewState = getFolderViewStateFromId(folderId);
    return viewState.color;
};

export const getCustomFolderColorHexValue = (colorId: string | undefined): string | undefined => {
    if (!colorId) {
        return undefined;
    }
    return colorId ? getFolderColor(colorId) : undefined;
};
